import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UpdateTipuriAmenziInterface } from './tipuri-amenzi-interface';

@Injectable({
    providedIn: 'root',
})
export class TipuriAmenziService {
    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;

    private updateTipuriAmenzi =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriAmenzi.updateTipAmenzi;

    private statusTipuriAmenzi =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriAmenzi.statusTipuriAmenzi;

    constructor(private http: HttpClient) { }

    updateAmenzi(data: UpdateTipuriAmenziInterface) {
        return this.http.put(
            this.updateTipuriAmenzi + data.id,
            data,
            this.httpOptions
        );
    }

    changeStatusActive(id: number) {
        return this.http.get(this.statusTipuriAmenzi + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
